import React from 'react';
import { observer } from 'mobx-react-lite';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

const PaginationLinks = observer(function PaginationLinks({ pageData }) {
  const currentParams = window.location.search;
  let searchParams = new URLSearchParams(currentParams);

  const urlBuilder = (page) => {
    searchParams.set('page', page);
    return `?${searchParams}`;
  };

  return (
    <Pagination
      page={pageData.currentPage}
      count={pageData.numPages}
      variant="outlined"
      shape="rounded"
      renderItem={(item) => (
        <PaginationItem
          component={'a'}
          href={urlBuilder(item.page)}
          {...item}
        />
      )}
    />
  );
});

export default PaginationLinks;
